import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Typography from '@/components/base/Typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type LegalsMenuProps = HTMLAttributes<HTMLElement> & {
  revealDelay?: number
}

const LegalsMenu = ({ className, revealDelay = 0, ...props }: LegalsMenuProps) => {
  const { menu } = useStore()

  return (
    <ul className={cn('flex space-x-spacing-xxs', className)} {...props}>
      {menu?.legals_menu.menu.map(({ url, target, title }, index) => (
        <li key={index} data-motion-legal>
          <Link
            href={url}
            target={target}
            scroll={false}
            className={cn([
              '-my-2 flex overflow-hidden py-2 pointer:hover:opacity-50',
              'transition-opacity duration-300 ease-out-cubic',
              {
                'pointer-events-none': url === '#'
              }
            ])}
          >
            <span
              className="label inline-flex"
              style={
                revealDelay > 0
                  ? {
                      transitionDelay: `${300 + 30 * (revealDelay + index)}ms`
                    }
                  : undefined
              }
            >
              <Typography variant="small">{title}</Typography>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default LegalsMenu
